import { render, staticRenderFns } from "./WcFormsAlerts.vue?vue&type=template&id=1f548db5&lang=pug&"
import script from "./WcFormsAlerts.vue?vue&type=script&lang=js&"
export * from "./WcFormsAlerts.vue?vue&type=script&lang=js&"
import style0 from "./WcFormsAlerts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports